'use strict';

angular.module('cimerFrontEndApp').controller('DashboardCtrl', ['$scope', '$location', 'Session', function ($scope, $location, Session) {

    // verify the user is authenticated before showing them the dashboard
    var sessionObject = Session.getSessionObject();
    if (!sessionObject.isAuthenticated) {
        $location.url('/');
        return;
    }

    $scope.displayName = null;

    Session.userDetails().then(function () {
        if (Session.user.FirstName !== null && Session.user.FirstName !== '') {
            $scope.displayName = Session.user.FirstName;
            if (Session.user.LastName !== null && Session.user.LastName !== '') { // only show the last name if they have a first name
                $scope.displayName = $scope.displayName + ' ' + Session.user.LastName;
            }
        }
    });
}]);